import React, { Component } from "react";
import {
  Button,
  CssBaseline,
  Typography,
  Box,
  Container,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  CircularProgress
} from "@material-ui/core";
import {withRouter} from 'react-router-dom';
import { Alert, AlertTitle } from '@material-ui/lab';
import {PURPLE_COLOR, VERSION_NUMBER, AGENT_SWAN, AGENT_CLINIC, AGENT_ADMIN, AGENT_PCL} from "../constants";
import {connect} from 'react-redux';
import {authenticateUser} from '../actions';
import swanlogo from "../media/logo-coloured.png";
const FORGOTPASSWORD_MSG =
  "Please contact SWAN for your password recovery procedure";
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {VERSION_NUMBER}
    </Typography>
  );
}
var pathToRedirect = "/SwanDashboard";
class Login extends Component {
  state = {
    logout:false,
    forgotpwd: false,
    login:'',
    password:'',
    loginerror:false,
    passworderror:false,
    loginerrormsg:'',
    passworderrormsg:'',
    showSnackbar:false,
    snackbarMessage:'',
    snackbartype:"success",
    isLoading:false,
    authSuccess:false
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  loginUser(){
    const {login,password} = this.state;
    if(login.length == 0){this.setState({loginerror:true,loginerrormsg:'Please enter your login.'});}
    if(password.length == 0){this.setState({passworderror:true,passworderrormsg:'Please enter your password.'});}
    if(login.length > 0 && password.length > 0){ this.setState({isLoading:true});
      if(!this.state.isLoading){this.props.authenticateUser(login,password);}
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.success){
      if(nextProps.data.usertype == AGENT_SWAN){
        pathToRedirect = "/SwanView";
      }

      if(nextProps.data.usertype == AGENT_CLINIC){
        pathToRedirect = "/ClinicView"
      }

      if(nextProps.data.usertype == AGENT_ADMIN){
        pathToRedirect = "/AdminView"
      }

      if(nextProps.data.usertype == AGENT_PCL){
        pathToRedirect = "/PCLView"
      }

      this.setState({showSnackbar:false,isLoading:false});
      this.props.history.push(pathToRedirect);
    }else{
      if(nextProps.displayMsg) this.setState({showSnackbar:true,snackbarMessage:nextProps.displayMsg,snackbartype:"error",isLoading:false});
    }
  }

  triggerLogin(e){
    if(e.keyCode == 13){ this.loginUser(); }
  }

  render() {
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div
          style={{
            marginTop: 16,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <form
            className={{
              width: "100%",
              marginTop: 8,
            }}
            noValidate
          >
            <div
              style={{
                display: "flex",
                margin: "auto",
                alignItems: "center",
                justifyContent: "center",
                padding: 15,
              }}
            >
              <img src={swanlogo} style={{ width: 175 }} />
              <Typography
                variant="h6"
                style={{
                  color: PURPLE_COLOR,
                  marginLeft: 10,
                  fontSize: 35,
                  marginTop: 20,
                }}
                noWrap
              >
                Portal
              </Typography>
            </div>

            <TextField
              variant="outlined" onChange={e=>this.setState({login:e.target.value})} value={this.state.login}
              margin="normal"
              required onKeyDown={(e)=>this.triggerLogin(e)}
              error={this.state.loginerror} helperText={this.state.loginerrormsg}
              fullWidth
              label="Login"
              autoFocus
            />
            <TextField
              variant="outlined" onChange={e=>this.setState({password:e.target.value})} value={this.state.password}
              margin="normal"
              required onKeyDown={(e)=>this.triggerLogin(e)}
              error={this.state.passworderror} helperText={this.state.passworderrormsg}
              fullWidth
              label="Password"
              type="password"
              autoComplete="current-password"
            />

            {!this.state.isLoading &&
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={()=>this.loginUser()}
              style={{ backgroundColor: PURPLE_COLOR, marginTop: 20 }}
            >
              Login
            </Button>}

            {this.state.isLoading &&
            <div
              style={{
                marginTop: 16,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
            }


            <Button
              fullWidth
              color="primary"
              style={{ marginTop: 20, color: PURPLE_COLOR }}
              onClick={() => this.setState({ forgotpwd: true })}
            >
              forgot password ?
            </Button>
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>

        <Dialog
          onClose={() => this.setState({ forgotpwd: false })}
          aria-labelledby="customized-dialog-title"
          open={this.state.forgotpwd}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={() => this.setState({ forgotpwd: false })}
          >
            Forgot your password ?
          </DialogTitle>
          <DialogContent>
            <Typography gutterBottom>{FORGOTPASSWORD_MSG}</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => this.setState({ forgotpwd: false })}
              color="primary"
              style={{ color: PURPLE_COLOR }}
            >
              okay
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar style={{marginBottom:'20%'}} open={this.state.showSnackbar} autoHideDuration={4000} onClose={()=>this.setState({showSnackbar:false})}>
          <Alert onClose={()=>this.setState({showSnackbar:false})} severity={this.state.snackbartype}>
            <AlertTitle>{this.state.snackbarMessage}</AlertTitle>
          </Alert>
        </Snackbar>
      </Container>
    );
  }
}

const mapStateToProps = (data) => {
  const {auth} = data;
  return auth;
}

export default connect (mapStateToProps,{authenticateUser})(withRouter(Login));
